const defaults = {
    uploaderParmas: {
        auto: true,
        // swf文件路径
        swf: '/webuploader/Uploader.swf',
        // 文件接收服务端。
        server: '/upload/upload/',
        // 内部根据当前运行是创建，可能是input元素，也可能是flash.
        pick: '.fileupload',
        // 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
        resize: false,
        fileVal: 'files',
        fileNumLimit: 9,
        fileSingleSizeLimit: 1024 * 1024* 2
    },
    isCreateOwnImg: false, // 是否需要自己在页面中创建图片，如果为true，则不生成默认的图片。而在页面中自行创建图片
    qNbeforeFileQueued: "", // 当文件被加入队列之前触发
    qNfileQueued: "", // 当文件被加入队列以后触发
    qNfilesQueued: "", // 当一批文件添加进队列以后触发
    qNfileDequeued: "", // 当文件被移除队列后触发
    qNuploadStart: "", // 某个文件开始上传前触发，一个文件只会触发一次
    qNuploadSuccess: "", // 当文件上传成功时触发
    qNuploadComplete: "", // 不管成功或者失败，文件上传完成时触发
    qNuploadError: "", // 当文件上传出错时触发
    qNuploadAccept: "", // 当某个文件上传到服务端响应后，会派送此事件来询问服务端响应是否有效。
    qNuploadProgress: "", // 上传过程中触发，携带上传进度。
    qNerror: "" // 捕获数量、大小、类型相关错误Q_EXCEED_NUM_LIMIT  Q_EXCEED_SIZE_LIMIT Q_TYPE_DENIED
};

class qiNiuWebUploader {

    constructor(element, options) {
        this.$ele = element;
        if (options && options.uploaderParmas) {
            options.uploaderParmas = Object.assign(defaults.uploaderParmas, options.uploaderParmas);
        }
        // 图片上传时候的限制宽高,尺寸为"width*height"
        this.imgLimitSize = "";
        this.opts = Object.assign(defaults, options);
        // 把选择器的cls直接赋值给当前的pick，要求页面中pick和上传选择的元素是同一个
        this.opts.uploaderParmas.pick = element.selector;
        // 这里保存下回调。是因为实例原型链引用的是同一个。如果页面上有多个上传就会导致，所有的上传都走的最后
        // 一个实例的成功回调
        this.successCb = this.opts.qNuploadSuccess;
        this.fileSize = this.opts.uploaderParmas.fileSingleSizeLimit;
        this.init();
    }

    init() {
        let that = this;

        return (function (_) {
            let _accept = _.opts.uploaderParmas.accept;

            // 如果不存在accept参数的话。那么默认可以上传图片类型
            let _acceptType = _accept && _accept.mimeTypes ? _accept.mimeTypes : "images/jpg,images/jpeg,images/png";

            return WebUploader.create(_.opts.uploaderParmas)
                .on('beforeFileQueued', (file, data) => {
                    let [fType, fssl] = [file.type, _.opts.uploaderParmas.fileSingleSizeLimit];
                    let [currMB, typeList] = [that.fileSize/1024/1024, fType.split("/")];
                    let [parentType, childType] = [typeList[0], typeList[1]];

                    // 判断是当前输入的类型是否图片，并且是*
                    if (_acceptType.indexOf("image") > -1) {

                        if (childType != 'jpg' && childType != "jpeg" && childType != "png") {
                            _.tipHandle("当前上传的文件类型不正确，请重新上传");
                            return false;
                        }
                        // 如果不是当前允许上传的文件类型
                        // 就提示上传文件类型不正确
                    } else if (_acceptType.indexOf(parentType) < 0) {
                        _.tipHandle("当前上传的文件类型不正确，请重新上传");
                        return false;
                    }
                    // 获取当前上传文件尺寸，与当前文件大小限制进行比较，如果大于当前限制的文件大小，就提示文件的大小不正确

                    if (file.source.size > that.fileSize) {
                        _.tipHandle("上传文件大小不能超过" + currMB + "M，请重新上传");
                        return false;
                    }
                    if (_.isFunction(_.opts.qNbeforeFileQueued)) {
                        _.opts.qNbeforeFileQueued.call(_, file, data);
                    }
                })
                .on('fileQueued', (file) => {
                    if (_.isFunction(_.opts.qNfileQueued)) {
                        _.opts.qNfileQueued.call(_, file);
                    }
                })
                .on('filesQueued', (file) => {
                    if (_.isFunction(_.opts.qNfilesQueued)) {
                        _.opts.qNfilesQueued.call(_, file);
                    }
                })
                .on('fileDequeued', (file) => {
                    if (_.isFunction(_.opts.qNfileDequeued)) {
                        _.opts.qNfileDequeued.call(_, file);
                    }
                })
                .on('uploadAccept', (file) => {
                    if (_.isFunction(_.opts.qNuploadAccept)) {
                        _.opts.qNuploadAccept.call(_, file);
                    }
                })
                .on('uploadStart', (file) => {

                    if (_.isFunction(_.opts.qNuploadStart)) {
                        _.opts.qNuploadStart.call(_, file);
                        return false;
                    }
                    _.$ele.append(`<div class="uploader-loading">
                                    <img src="//static.scimall.org.cn/simditor/images/loading.gif"/>
                                    </div>`);
                })
                .on('uploadProgress', (file, percentage) => {
                    if (_.isFunction(_.opts.qNuploadProgress)) {
                        _.opts.qNuploadProgress.call(_, file, percentage);
                    }
                })
                .on('uploadError', function (file, reason) {
                    this.reset();
                    _.tipHandle("上传失败");

                    if (_.isFunction(_.opts.qNuploadError)) {
                        _.opts.qNuploadError.call(_, file, reason);
                    }
                })
                .on('uploadSuccess', (file, { msg, code, data }) => {
                    if (code > 0) {
                        _.tipHandle(res.msg);
                        return false;
                    }
                    let [filename, fileurl] = [data.name, data.url];
                    let isCreateOwnImg = _.opts.isCreateOwnImg,
                        imgCon = $(".uploader-imgs"),
                        img = new Image();

                    // 插入图片的操作
                    function createImg() {
                        // 如果当前的上传文件类型是图片。就默认插入一张图片
                        if (!isCreateOwnImg && _acceptType.indexOf("image") > -1) {
                            if (!imgCon.length) {
                                _.$ele.append(`<div class="uploader-imgs" data-name="${filename}">
                                                <img src="${fileurl}"/></div>`);
                            } else {
                                imgCon.attr("data-name", filename).show().find("img").attr("src", fileurl);
                            }
                        }

                        // 如果存在回调就调用回调
                        if (_.isFunction(that.successCb)) {
                            that.successCb.call(_, filename, fileurl, file);
                        }
                    }
                    // 如果有传入限制的图片尺寸
                    // 就通过一个image标签来确定当前上传图片的
                    // 尺寸是否符合
                    if (_.imgLimitSize) {
                        let limitArr = _.imgLimitSize.split("*");
                        let [limitW, limitH]= [limitArr[0], limitArr[1]];

                        img.src = fileurl;
                        img.onload = function () {
                            let [w, h] = [img.width, img.height];

                            // 宽度和高度有一个不符合限制尺寸。就是不符合限制
                            if (w != limitW || h != limitH) {
                                _.tipHandle(_.sizeNotMatchMsg);
                                return false;
                            } else {
                                createImg();
                            }
                        };
                    } else {
                        createImg();
                    }
                })
                .on('uploadComplete', function (file) {
                    if (_.isFunction(_.opts.qNuploadComplete)) {
                        _.opts.qNuploadComplete.call(_, file);
                        return false;
                    }
                    _.$ele.find('.loading').remove();
                    this.reset();
                })
                .on('error', (file, handler) => {
                    if (_.isFunction(_.opts.qNerror)) {
                        _.opts.qNerror.call(_, file, handler);
                    }
                });
        })(this);
    }

    isFunction(fn) {
        return typeof fn == "function";
    }

    tipHandle(msg) {
        layer.msg(msg);
    }

    setImgLimitSize(size, msg) {
        this.imgLimitSize = size;
        this.sizeNotMatchMsg = msg || "当前上传的文件的尺寸不符，请重新上传";
    }
}

export function qiNiuUploader($ele, options) {
    return new qiNiuWebUploader($ele, options);
}

